<template>
  <div class="item-card" :class="[`${item.status}-item`]">
    <div class="item-card__inner">
      <img :src="item.image_urls[0]" class="item-card__img" />
      <div class="item-card__description">
        <BlFlexContainerMv style="height: 32px;">
          <BlTextAv :ellipsis="2" variation="caption-12" weight="bold">
            {{ item.name }}
          </BlTextAv>
          <IcoChevronRightMinor
            v-if="!['upcoming', 'disabled', 'onhold'].includes(item.status)"
            style="margin-left: auto; align-self: flex-end; height: 20px;"
          />
        </BlFlexContainerMv>
        <BlCapsuleAv
          :variation="badgeVariation"
          size="small"
          class="u-align-center mt-8"
          style="width: 100%"
        >
          {{ statusLabel }}
        </BlCapsuleAv>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BlCapsuleAv,
  BlFlexContainerMv,
  BlTextAv,
} from '@bukalapak/bazaar-mweb';
import IcoChevronRightMinor from '@bukalapak/bazaar-visual-v1/dist/components/IcoChevronRightMinor';
import STATUS_MAP from '../constants/statusMap';

export default {
  name: 'ItemCard',
  components: {
    BlFlexContainerMv,
    BlCapsuleAv,
    BlTextAv,
    IcoChevronRightMinor,
  },
  props: {
    item: {
      required: true,
      type: Object,
    },
  },
  computed: {
    badgeVariation() {
      const variations = {
        active: 'informational',
        success: 'success',
        upcoming: 'secondary',
        disabled: 'critical',
        onhold: 'critical',
      };
      return variations[this.item.status] ?? 'secondary';
    },
    statusLabel() {
      return (
        this.item.humanized_status ??
        STATUS_MAP[this.item.status] ??
        this.item.status
      );
    },
  },
};
</script>

<style lang="scss">
.item-card {
  max-width: 100px;
  border-radius: 4px;
  overflow: hidden;
  margin: 0 auto;
  background: #fff;
  box-shadow: 0px 1px 5px 0px rgba(31, 31, 31, 0.15);

  &__img {
    display: block;
    width: 100%;
    min-height: 100px;
    height: auto;
  }

  &__description {
    background: #f7f7f7;
    padding: 8px;
  }
}

.upcoming-item .item-card__inner {
  opacity: 0.5;
}
.disbled-item .item-card__inner {
  opacity: 0.5;
}
.onhold-item .item-card__inner {
  opacity: 0.5;
}
</style>
